<section class="main-content wrapper content-padding">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link active-tab"
        >
          PRODOTTI
        </a>
      </label>
    </div>
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/prodotti/attiva"
          routerLinkActive="active-tab"
        >
          ATTIVA PRODOTTI
        </a>
      </label>
  
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/prodotti/archivio"
          routerLinkActive="active-tab"
        >
          ARCHIVIO PRODOTTI
        </a>
      </label>

      <label class="tab" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <a
          class="tab-link"
          routerLink="/prodotti/shopify"
          routerLinkActive="active-tab"
        >
          SHOPIFY PRODOTTI
        </a>
      </label>
    </div>
    <router-outlet></router-outlet>
  </div>
</section>
